export default "__VITE_ASSET__Bcyz9XgC__"